export class CancelEnrollmentRequest {
    totalItems: number;
    isMultiSelect?: boolean;
    items: CancelEnrollmentRequestItem[]

    constructor() {
        this.totalItems = 0;
        this.isMultiSelect = false;
        this.items = new Array<CancelEnrollmentRequestItem>();
    }
}

export class CancelEnrollmentRequestItem {
    requestID: number
    enrollmentName: string;
    isSelected: boolean;
    isRequired: boolean;

    constructor(){
        this.requestID = 0;
        this.enrollmentName = null;
        this.isSelected = false;
        this.isRequired = false;
    }
}

export class CancelEnrollmentRequestPayload {
    requestIDs: number[];

    constructor() {
        this.requestIDs = new Array<number>();
    }
}